import { apiClient } from '@/lib/api-client'

export interface AppUser {
  id: number
  username: string
  email: string
  name: string
  is_admin?: boolean
  is_active?: boolean
  last_login?: string | null
  has_password?: boolean
}

export interface Member {
  user_id: number
  username: string
  email: string
  name: string
  role: 'owner' | 'editor' | 'viewer'
}

/** Everyone can list users — sharing a collection needs to pick one. */
export async function getUsers(): Promise<AppUser[]> {
  const { data } = await apiClient.get<{ users: AppUser[] }>('/auth/users')
  return data.users ?? []
}

export async function createUser(input: {
  username: string
  name: string
  email?: string
  password: string
  is_admin?: boolean
}) {
  const { data } = await apiClient.post('/auth/users', input)
  return data
}

export interface UserPermissionsUpdate {
  is_admin?: boolean
  is_active?: boolean
}

export async function updateUserPermissions(
  userId: number,
  permissions: UserPermissionsUpdate,
): Promise<AppUser> {
  const { data } = await apiClient.patch<AppUser>(`/auth/users/${userId}`, permissions)
  return data
}

export async function changePassword(currentPassword: string, newPassword: string) {
  const { data } = await apiClient.post('/auth/password', {
    current_password: currentPassword,
    new_password: newPassword,
  })
  return data
}

export async function getMembers(collectionId: number): Promise<Member[]> {
  const { data } = await apiClient.get<{ members: Member[] }>(
    `/collections/${collectionId}/members`,
  )
  return data.members ?? []
}

export async function shareCollection(collectionId: number, userId: number, role: string) {
  const { data } = await apiClient.post(`/collections/${collectionId}/members`, {
    user_id: userId,
    role,
  })
  return data
}

export async function unshareCollection(collectionId: number, userId: number) {
  const { data } = await apiClient.delete(`/collections/${collectionId}/members/${userId}`)
  return data
}
